import { Collections } from "@mui/icons-material";
import * as Yup from "yup";
export interface ShoppingPortal {
  id?: string;
  portalName: string;
  primaryPhone: string;
  email: string;
  about: string;
  invoiceNote?: string;
  secondaryPhone?: string;
  portalLogoName?: string; //To keep track that already uploaded Logo is exists or not
  address: string;
  facebookURL?: string;
  twitterURL?: string;
  instagramURL?: string;
  linkedInURL?: string;
  portalType:PartsPortalType;
  isPortalEnabled:boolean;
  portalLogo: File | null;
  bannerImages: File[];
  shippingCharge: number;
  storefrontAccessToken: string;
  hideMfgs?: string[];
  activeManufacturerFilter?: boolean;
  activeCategoryFilter?: boolean;
}

export enum SocialLinkType {
  Facebook,
  Twitter,
  Instagram,
  LinkedIn,
}
export enum PortalImageType {
  Banner,
  Logo,
}
export enum PartsPortalType
{
    StandAlone,
    Embedded
}
export const ShoppingPortalInitialValues: ShoppingPortal = {
  id: "",
  portalName: "",
  primaryPhone: "",
  email: "",
  about: "",
  invoiceNote: "",
  secondaryPhone: "",
  portalLogoName: "",
  address: "",
  facebookURL: "",
  linkedInURL: "",
  instagramURL: "",
  twitterURL: "",
  portalLogo: null,
  bannerImages: [],
  shippingCharge: 0,
  storefrontAccessToken: "",
  hideMfgs: [],
  portalType:PartsPortalType.StandAlone,
  isPortalEnabled:true
};
export const ShoppingPortalValidationSchema = Yup.object().shape({
  portalName: Yup.string().required("Portal Name is a required field"),
  primaryPhone: Yup.string().required("Primary Phone is required field"),
  email: Yup.string()
    .required("Email is required field")
    .email("Enter valid Email Address"),
  about: Yup.string()
    .required("About is required field")
    .max(2000, "Maximun 2000 characters are allowed"),
  address: Yup.string().required("Address is required field"),
  portalLogoName: Yup.string(),
  facebookURL: Yup.string()
    .url("Please enter a valid URL")
    .matches(
      /^(https?:\/\/)?(www\.)?facebook\.com\/.*/,
      "Please enter a valid Facebook profile URL"
    ),
  linkedInURL: Yup.string()
    .url("Please enter a valid URL")
    .matches(
      /^(https?:\/\/)?(www\.)?linkedin\.com\/.*/,
      "Please enter a valid LinkedIn profile URL"
    ),
  twitterURL: Yup.string()
    .url("Please enter a valid URL")
    .matches(
      /^(https?:\/\/)?(www\.)?(twitter|x)\.com\/.*/,
      "Please enter a valid X profile URL"
    ),
  instagramURL: Yup.string()
    .url("Please enter a valid URL")
    .matches(
      /^(https?:\/\/)?(www\.)?instagram\.com\/.*/,
      "Please enter a valid Instagram profile URL"
    ),
  portalLogo: Yup.mixed().when("portalLogoName", {
    is: (portalLogoName: any) => portalLogoName === "Exist",
    then: Yup.mixed().notRequired(),
    otherwise: Yup.mixed()
      .required("Portal Logo is a required field")
      .test(
        "fileFormat",
        "Invalid file format, only JPG, PNG are allowed",
        (value) => {
          if (value === null) return true;
          if (!value?.type) return false;
          const supportedFormats = ["image/jpeg", "image/png", "image/jpg"];
          return supportedFormats.includes(value.type);
        }
      ),
  }),
  bannerImages: Yup.array().of(
    Yup.mixed().test(
      "fileFormat",
      "Invalid file format, only JPG, PNG are allowed",
      (value) => {
        if (value === null) return true;
        if (!value?.type) return false;
        const supportedFormats = ["image/jpeg", "image/png", "image/jpg"];
        return supportedFormats.includes(value.type);
      }
    )
  ),
  shippingCharge: Yup.number()
    .min(0)
    .max(999)
    .required("Please enter a the Shipping charges"),
});
